import React, { Component } from 'react'
import Icon from 'components/icon/icon'
import { updateMilestone, openModal } from 'state/actions'
import { connect} from 'react-redux'

import MobileSubMenu from 'components/mobile/mobile-sub-menu'

import DragHandle from 'components/drag-handle/drag-handle'

import { isMobile } from 'utils'

class MilestoneName extends Component {
    constructor(props) {
        super(props);

        this.state = {
            editing: false,
            name: props.name,
            showDragHandle: false,
        }
    }

    toggleEditMilestoneName = _ => {
        this.setState({
            editing: !this.state.editing,
        })

        setTimeout(_ => {
            this.refs.milestoneName.focus()
        })
    }

    updatemilestoneName = e => {
        this.setState({
            name: e.target.value,
        })
    }

    UNSAFE_componentWillMount(){
        if(this.props.areMilestonesReordering){
            setTimeout(_ => {
                this.setState({
                    showDragHandle: true
                })
            })
        }
    }

    UNSAFE_componentWillUpdate = (nextProps) => {
        if(this.props.milestone.name !== nextProps.milestone.name){
            this.setState({
                name: nextProps.milestone.name
            })
        }
    }

    savemilestoneNameChange = _ => {
        if(this.state.name.length < 1) {
            return
        }

        const data = {
            id: this.props.milestone.id,
            name: this.state.name
        }

        this.props.updateMilestone(data, 'milestone', this.props.index)

        this.setState({
            editing: false,
        })
    }

    duplicateMilestone = _ => {
        const {
            milestone,
            openModal
        } = this.props

        openModal('duplicate','milestone', { 
            milestone
        })
    }

    render() {
        const { 
            areEntitiesRecoverable,
            milestone, 
            index, 
            deleteMilestone, 
            restoreMilestone,
            isShowingArchived,
            areMilestonesReordering,
            openModal,
            taskNameWidth,
            isOpen,
            isMini,
            collapseCallback,
            isProjectEditable,
            setMobileSubMenuOpenStatus,
            isPlanning
        } = this.props

        const {
            editing,
            showDragHandle,
            name
        } = this.state

        let className = 'milestone-name'

        if(editing){
            className += ' edited'
        }

        if(showDragHandle){
            className += ' draggable'
        }

		const mobilesubMenuOptions = [
            {
                icon: isOpen ? 'angle-up' : 'angle-down',
                label: isOpen ? 'Collapse' : 'Expand',
                callback: collapseCallback
            },
        ]
        
        if(isProjectEditable){
            mobilesubMenuOptions.push({
				icon: 'fe-edit-2',
				label: 'Edit name',
				callback: _ => {
                    openModal('edit','milestone', { 
                        milestone,
                        project_id: null
                    })
                }
            })
            
            mobilesubMenuOptions.push({
				icon: 'fe-trash-2',
				label: 'Archive',
				callback: _ => {
                    deleteMilestone(milestone, index)
                }
            })
            
            mobilesubMenuOptions.push({
                icon: 'copy',
                label: 'Duplicate milestone',
                callback: this.duplicateMilestone
            })
        }

        return (
            <div className={className} style={{ width: taskNameWidth }}>
                <DragHandle />
                <input 
                    type="text"
                    onChange={this.updatemilestoneName} 
                    onKeyPress={e => {(e.key === 'Enter' ? this.savemilestoneNameChange() : null)}} 
                    readOnly={!editing}
                    value={name}
                    ref="milestoneName"
                />
                {
                    (!isShowingArchived && !isMobile() && isProjectEditable && !isMini && !isPlanning) &&
                    <ul className={areMilestonesReordering == true ? 'hidden' : null }>
                        <li className="tooltip-trigger">
                            <Icon onClick={this.duplicateMilestone} name="copy" />
                            <div className="tooltip">
                                Duplicate milestone
                            </div>
                        </li>
                        <li className="tooltip-trigger">
                            <Icon onClick={this.toggleEditMilestoneName} name="fe-edit-2" />
                            <div className="tooltip">
                                Edit milestone
                            </div>
                        </li>
                        <li className="tooltip-trigger">
                            <Icon onClick={_ => {deleteMilestone(milestone, index)}} name="fe-trash-2" />
                            <div className="tooltip">
                                Archive milestone
                            </div>
                        </li>
                        <li>
                            <Icon onClick={this.savemilestoneNameChange} name="check" />
                        </li>
                        <li>
                            <Icon onClick={this.toggleEditMilestoneName} name="ban" />
                        </li>
                    </ul>
                }
                { (isShowingArchived && !isMobile() && (isProjectEditable || areEntitiesRecoverable)) && !isMini &&
                    <ul>
                        <li className="tooltip-trigger">
                            <Icon onClick={_ => {restoreMilestone(milestone)}} name="reply" />
                            <div className="tooltip">
                                Restore milestone
                            </div>
                        </li> 
                        <li className="tooltip-trigger">
                            <Icon onClick={_ => {deleteMilestone(milestone, index)}} name="fe-trash-2" />
                            <div className="tooltip">
                                Delete milestone
                            </div>
                        </li> 
                    </ul>
                }
                { isMobile() &&
                    <MobileSubMenu 
                        options={mobilesubMenuOptions} 
                        setOpenStatus={setMobileSubMenuOpenStatus}
                    />
                }
            </div>
        )
    }
}

export default connect(null, { updateMilestone, openModal })(MilestoneName);